<template>
  <ul class="menu" @click="$emit('actionClicked')">
    <li v-if="canEdit" class="menu__item">
      <RouterLink
        :to="{
          name: `${routeBaseName}.edit`,
          params: {
            ...this.$route.params,
            pageId,
          },
        }"
        class="menu__link"
      >
        {{ $t('global.edit') | capitalize }}
      </RouterLink>
    </li>
    <li v-if="canDelete" class="menu__item">
      <RouterLink
        :to="{
          name: `${routeBaseName}.delete`,
          params: {
            ...this.$route.params,
            pageId,
          },
        }"
        class="menu__link"
      >
        {{ $t('delete') | capitalize }}
      </RouterLink>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'DataIteratItemActions',
  props: {
    routeBaseName: {
      type: String,
      required: true,
    },
    pageId: {
      type: String,
      required: true,
    },
    canEdit: Boolean,
    canDelete: Boolean,
  },
};
</script>
